var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMd)?_c('brand-list-table',{attrs:{"list":_vm.list}}):_c('brand-list-block',{attrs:{"list":_vm.list}})
}
var staticRenderFns = []

export { render, staticRenderFns }